"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreviewSupportLevel = void 0;
const isPreviewSupportLevel = (supportLevel) => {
    return supportLevel === 'dev-preview' || supportLevel === 'tech-preview';
};
exports.isPreviewSupportLevel = isPreviewSupportLevel;
//# sourceMappingURL=featureSupportLevel.js.map